import styled from "styled-components";

import { colors, radii } from "shared/ui/tokens";

export const Zone = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const ZoneLabel = styled.span`
    color: ${colors.fieldLabel};
    font-size: 13px;
`;

export const SelectedRow = styled.div`
    display: flex;
    /* react-beautiful-dnd не поддерживает переносящиеся списки: при flex-wrap он считает
       позиции по одной строке, и чипы со второй прыгают. Поэтому прокрутка, а не перенос. */
    flex-wrap: nowrap;
    align-items: center;
    gap: 8px;
    min-height: 44px;
    overflow-x: auto;
`;

export const SelectedChip = styled.div<{ $dragging: boolean }>`
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 4px 4px 6px;
    border: 1px solid ${({ $dragging }) => ($dragging ? colors.primary : colors.borderSoft)};
    border-radius: ${radii.chip};
    background: ${colors.surface};
    /* Курсор подсказывает, что порядок чипов можно менять перетаскиванием. */
    cursor: grab;
`;

export const HiddenMark = styled.span`
    color: ${colors.textSecondary};
    font-size: 12px;
`;

export const AvailableRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;

export const AddButton = styled.button`
    padding: 0;
    border: 0;
    background: none;
    cursor: pointer;
    opacity: 0.55;
    transition: opacity 0.15s;

    &:hover,
    &:focus-visible {
        opacity: 1;
    }
`;

export const Empty = styled.p`
    margin: 0;
    color: ${colors.textSecondary};
    font-size: 13px;
`;
